<div class="footer">
  <!-- <div class="text-center pt-[14px] pb-[14px] relative" *ngIf="isShowCheckItNow" >
    <span class="text-white mr-6 font-medium">{{'footer.text1' | translate}}</span>
    <button class="btn bg-lightyellow h-[36px] pl-2 pr-2 text-[12px]"><span class="mr-2 align-middle">{{'footer.check-it-now' | translate}}</span> <span class="material-icons text-[20px]">east</span></button>

    <div (click)="hideCheckItNow()" class="absolute right-4 top-4 cursor-pointer"><span class="material-icons text-white">close</span></div>
  </div> -->
  <div class="flex pt-4 pb-4 pl-12 pr-12 items-center">
    <span class="font-medium text-white" translate="app.version-footer" [translateParams]="{version: versionName}"></span>
    <div class="flex-1"></div> 
    <!-- <a routerLink="/privacy-policy" class="mr-[42px] font-medium">{{'common.privacy-policy' | translate}}</a>
    <a routerLink="/cookie-policy" class="font-medium">{{'common.cookies-policy' | translate}}</a> -->
  </div>
</div>

<div class="rbe-footer application-page py-4 lg:py-6 px-[16px] lg:px-[48px]" style="border-top: 1px solid var(--gainsboro-color)">
  <div class="flex flex-col lg:flex-row">
    <div class="flex-1">
      <div class="max-w-[912px]">
        <p>{{(theme === 'Storey' ? 'storey.footer.text' : 'footer.text') | translate}}
        </p>
      </div>
    </div>
    <div class="mb-4 ml-0 lg:ml-8 lg:mb-0">
      <ul class="m-0 px-0 mt-4 list-none list-outside">
        <li class="ml-0"><a [href]="getLinkPrivacyPolicy()" class=" no-underline text-black">Privacy Policy</a></li>
        <li class="ml-0 mt-2">{{(theme === 'Storey' ? 'storey.footer.copyright-text' : 'footer.copyright-text') | translate}}</li>
        <li class="ml-0 mt-2">Powered by: Rezpage Property Management system</li>
      </ul>
    </div>
  </div>
</div>